import { KeyboardEvent, ReactNode } from 'react';

type FieldCodeButtonProps = {
  jsonpath: string;
  onFieldClick: (jsonpath: string) => void;
  children?: ReactNode;
};

export const FieldCodeButton = ({ jsonpath, onFieldClick, children }: FieldCodeButtonProps) => (
  <code
    role="button"
    tabIndex={0}
    className="cursor-pointer rounded-sm border border-gray-200 px-1 py-0.5 font-mono break-all text-procuros-green-700 hover:bg-gray-100"
    onClick={() => onFieldClick(jsonpath)}
    onKeyDown={handleKeyDown(() => onFieldClick(jsonpath))}
  >
    {children}
  </code>
);

const handleKeyDown = (callback: () => void) => (e: KeyboardEvent) => {
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault();
    callback();
  }
};
